export default __webpack_public_path__ + "static/media/brooks.1557f774.png";